import "./Treatments.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import DeliveryOptions from "./sections/DeliveryOptions";
import FeaturedPromotions from "./sections/FeaturedPromotions";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import Footer from "@/reusable_sections/Footer";
export default function TreatmentsPage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <DeliveryOptions />
      <FeaturedPromotions />
      <CustomerTestimonials />
      <Footer />
    </div>;
}